import * as React from 'react'

function SvgTrwi(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="60"
      height="35"
      viewBox="0 0 60 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M59.352 16.457C59.352 13.0466 56.9761 10.6479 53.6453 10.6479C49.405 10.6479 46.563 13.7287 46.563 18.1281C46.563 21.5612 48.9617 23.9371 52.3493 23.9371C55.43 23.9371 57.7264 22.4479 58.6699 20.072H55.2482C54.7934 20.8109 53.8272 21.277 52.6449 21.277C50.826 21.277 49.6892 20.072 49.5869 18.3668H59.1587C59.2838 17.7188 59.352 17.1618 59.352 16.457ZM49.8484 16.0591C50.1553 14.4903 51.6786 13.2398 53.5202 13.2398C55.1117 13.2398 56.3167 14.3994 56.3167 16.0591H49.8484Z"
        fill="#2E4369"
      />
      <path
        d="M37.3664 23.63L37.9803 20.356C39.856 20.7312 40.1402 19.674 40.629 17.1275L40.8677 15.8657C41.5498 12.3075 42.9253 10.5341 46.8586 11.0116L46.2448 14.2856C44.369 13.9104 44.0394 15.3314 43.6188 17.5368L43.38 18.7986C42.698 22.4023 41.277 24.1075 37.3664 23.63Z"
        fill="#2E4369"
      />
      <path
        d="M32.7737 23.6417L35.0928 10.9551H38.1508L35.8431 23.6417H32.7737Z"
        fill="#2E4369"
      />
      <path
        d="M15.2557 10.9551H18.2228L19.189 20.129L23.0769 10.9551H26.0212L27.0557 20.22L30.8071 10.9551H33.7627L28.3857 23.6417H25.0208L23.9295 14.9111L20.2122 23.6417H16.9609L15.2557 10.9551Z"
        fill="#2E4369"
      />
      <path
        d="M4.17201 14.32L0.647949 17.6849H6.63885L7.26409 16.2184H4.22885L6.1273 14.32L5.02461 12.4215H10.1743L5.42248 23.6417H7.20725L12.5843 10.9551H2.19399L4.17201 14.32Z"
        fill="#00B9FF"
      />
    </svg>
  )
}

export default SvgTrwi
